/**
 * @author [zhaowenjie08]
 * @email [zhaowenjie08@58.com]
 * @create date 2022-02-10 17:53:01
 * @modify date 2022-02-10 17:53:01
 * @desc [项目配置]
 */
export const excludeAssetWhiteList: string[] = ['//s.anjuke.com/', '//api.map.baidu.com']

interface SubAppProps {
  props?: { base?: string; };
  name: string;
  activeRule: string;
  entry: string;
}

export const subappConfig: SubAppProps[] = [
  // warn：非相对应业务线负责人，配置都不可随意变更
  { name: 'mendian-web', activeRule: '/solar/metis', entry: '/metis/fetch/subapp4solar/resource' },
  { name: 'esf-web', activeRule: '/solar/esf-fe', entry: '//qiye.anjuke.com/esf-fe/mendian/index.html' },
  // 王野(wangye16)
  { name: 'vip-zufang', activeRule: '/solar/zufang', entry: '/zufang/' },
  // 集中式公寓入口 已申请mendian和qiye两个域名流量 @maxiaolin
  { name: 'condo-web', activeRule: '/solar/condo', entry: '/condo' },
  // @高夕毓(gaoxiyu)
  { name: 'esf-broker-mix', activeRule: '/solar/mix', entry: '/esf-broker-mix' },
  // venus子应用门店中支持 @zhaowenjie
  { name: 'venus', activeRule: '/threenets/venus', entry: 'https://vip.anjuke.com/solar/fetch/subvenus4threenets/resource' },
  // 二手房原经纪人仓库子应用，特价房入口，仅支持https @zhangfenghua
  { name: 'esf-broker-vip', activeRule: '/solar/vip', entry: 'https://vip.anjuke.com/esf-fe/broker/index.html' }
]

export const getSubAppConfig = (loader: unknown): Record<string, any>[] => {
  return subappConfig.map((item: SubAppProps) => {
    const config: Record<string, any> = {
      name: item.name,
      entry: item.entry,
      container: '#subapp-viewport',
      loader,
      activeRule: item.activeRule
    }
    // 兼容 umi 子应用 base 设置不带 solar 的情况
    if (item.activeRule === '/solar/condo') {
      config.props = {
        base: '/solar/condo'
      }
    }
    return config
  })
}
